import React from 'react';
import CRUDList from '../Common/CRUDList';
import { planeModels } from '../../services/api';
import { aircraftManufacturers } from '../../constants/aircraftManufacturers';

function PlaneModelForm({ formData, setFormData }) {
  return (
    <>
      <div className="form-group">
        <label>Manufacturer *</label>
        <select
          value={formData.pmodel_manufacturer || ''}
          onChange={(e) => setFormData({ ...formData, pmodel_manufacturer: parseInt(e.target.value) })}
          required
        >
          <option value="">Select manufacturer</option>
          {Object.entries(aircraftManufacturers).map(([key, value]) => (
            <option key={key} value={key}>{value}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Designation *</label>
        <input
          type="text"
          value={formData.pmodel_designation || ''}
          onChange={(e) => setFormData({ ...formData, pmodel_designation: e.target.value })}
          required
          maxLength={64}
          placeholder="e.g., 737-800, A320neo"
        />
      </div>

      <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <div>
          <label>IATA Code</label>
          <input
            type="text"
            value={formData.pmodel_iata_code || ''}
            onChange={(e) => setFormData({ ...formData, pmodel_iata_code: e.target.value.toUpperCase().slice(0, 3) })}
            maxLength={3}
            placeholder="e.g., 73H"
          />
        </div>
        <div>
          <label>ICAO Code</label>
          <input
            type="text"
            value={formData.pmodel_icao_code || ''}
            onChange={(e) => setFormData({ ...formData, pmodel_icao_code: e.target.value.toUpperCase().slice(0, 4) })}
            maxLength={4}
            placeholder="e.g., B738"
          />
        </div>
      </div>
    </>
  );
}

function PlaneModelsList() {
  return (
    <CRUDList
      title="Plane Models"
      api={planeModels}
      columns={['ID', 'Manufacturer', 'Designation', 'IATA', 'ICAO']}
      FormComponent={PlaneModelForm}
      defaultFormData={{
        pmodel_manufacturer: '',
        pmodel_designation: '',
        pmodel_iata_code: '',
        pmodel_icao_code: ''
      }}
      useOldStyle={true}
      renderRow={(item) => (
        <>
          <td>{item.pmodel_id}</td>
          <td>{aircraftManufacturers[item.pmodel_manufacturer] || `Unknown (${item.pmodel_manufacturer})`}</td>
          <td><strong>{item.pmodel_designation}</strong></td>
          <td>{item.pmodel_iata_code || '—'}</td>
          <td>{item.pmodel_icao_code || '—'}</td>
        </>
      )}
    />
  );
}

export default PlaneModelsList;
